export default __webpack_public_path__ + "static/media/no_user_512.05d0404a.png";